  import { Component, OnInit } from '@angular/core';
  import {DoctorService} from '../../services/doctor.service';
  import {Serviceprovider} from '../../classes/serviceprovider.interface';
  import { Specialisation} from '../../classes/specialisation.interface';
  import {Specialist} from '../../classes/specialisation.interface';
import { CommonService } from '../../services/common.service';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
// import 'rxjs/add/operator/map';
import { MatDialog, MatDialogRef } from '@angular/material';
import { MapdirectionComponent } from '../../pulse/mapdirection/mapdirection.component';
import { Router, ActivatedRoute,Params } from '@angular/router';
import { ShowservicesComponent } from '../../pulse/showservices/showservices.component';
@Component({
    selector: 'app-doctor',
    templateUrl: './doctor.component.html',
    styleUrls: ['./doctor.component.css']
  })
  export class DoctorComponent implements OnInit, OnDestroy {
    length: any;
    searchflag: number;
    sstatus: number;
    public loading = false;
    doctor: Serviceprovider[];
    searchterm: any;
    special: any;
    speci: any;
    servicemunus = [];
    services: any;
    p = 1;
    lat: any;
    lon: any;
    currentLocation: any;
    constructor(private doctorService: DoctorService, private commonService: CommonService,
      public dialog: MatDialog, private router: Router) {
      this.sstatus = 0;
     // this.commonService.pulsemenuflagstatus.next(1);
     this.commonService.setPulseMenuFlag(1);
      this.commonService.specializationfilterid.subscribe((x) => {
        this.speci = x;
        if(this.speci != 0){
          this.getspecialist(this.speci);
        }
      });

      this.commonService.lat.subscribe((x) => {
        this.lat = x;
      });
      this.commonService.lon.subscribe((x) => {
        this.lon = x;
      });
      this.commonService.geosetflagvalue.subscribe((x) => {
        const gsfvalue = x;
        if (gsfvalue == 1) {
          this.getNewPosition();
        }
      });
      this.commonService.doctornameflagvalue.subscribe( (x) => {
        this.searchterm = x;
        if (this.searchterm == 'na' || this.searchterm == null ) {
          this.searchflag = 1;
        }else {
          this.searchflag = 0;
        }
      });
    }

    ngOnInit() {
      this.loading = true;
      this. getServiceProvider();
      this.doctorService.getAllServicess()
      .subscribe(
        (x) => {
          this.services = x;
        });
    }
    getNewPosition() {
      this.currentLocation = {'lat': this.lat, 'lon': this.lon};
    }
    getServiceProvider() {
      this.doctorService.getDoctors()
      .subscribe(
        (doctor: Serviceprovider[]) => {
         this.loading = false;
          this.doctor = doctor;
        this.sstatus = 1;
        for (let i = 0; i < this.doctor.length; i++) {
         this.getServicesForDoctor(this.doctor[i].id);
        }
        });
    }
    getServicesForDoctor(sid) {
      this.doctorService.getServiceMenus(sid)
      .subscribe( (x) => {
        const temp = x;
        this.length = temp.length;
       
        if ( temp && temp.length > 0) {
          for (let i = 0 ; i < temp.length ; i++) {
            this.servicemunus.push(temp[i]);
          }
        }

      });
    }
    showServices(id) {
      const dialogRef = this.dialog.open( ShowservicesComponent, {
        width: '800px',
        height: '400px',
        data: {'id': id}
      });
    }


    getDirection(lat, lon) {
      const dialogRef = this.dialog.open( MapdirectionComponent, {
        width: '600px',
        height: '600px',
        data: {'lat': lat, 'lon': lon , 'lato': this.lat, 'lono': this.lon}
      });
    }
    ngOnDestroy() {
      this.commonService.setPulseMenuFlag(0);
     // this.commonService.pulsemenuflagstatus.next(0);
      this.commonService.specialisationfilter.next(0);
      this.commonService.latitude.next(0.0);
      this.commonService.longitude.next(0.0);
      this.commonService.doctornameflag.next('na');
    }
    bookAppointment(id) {
      const flag = 7;
      this.commonService.setActivatepath(flag);
       this.router.navigate(['/pulse/AppointmentBooking/' + id]);
    }
  getspecialist(spid) {
    this.loading = true;
    this.doctorService.getSpecialist(spid)
    .subscribe(
      (x) => {
        this.special = x;
        this.loading = false;
      });
   }
  }
